import cx from 'classnames';

import { ReactComponent as Close } from '../../assets/img/icons/common/Close.svg';

import './Modal.scss';

export const SideModal = ({
  title,
  customTitle = false,
  size = null,
  modalBody,
  modalRef,
  bodyRef,
  confirmText = null,
  cancelText = null,
  onCancel,
  onConfirm,
  confirmDisabled = false,
  confirmLoading = false,
  customButtons = null,
  withoutPadding = false,
  hasFooter = true,
  className = '',
}) => {
  return (
    <div
      className={cx('modal modal__side-container', { [className]: !!className })}
      id="side_modal"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
      ref={modalRef}
    >
      <div
        role="document"
        className={`modal-dialog modal__side modal__pattern-sm ${size !== null ? `modal__side-${size}` : ''}`}
      >
        <div className="modal-content">
          <div className="modal-header">
            {!customTitle ? <h4 className="modal-title">{title}</h4> : customTitle}
            <div className="modal-close__button" onClick={() => onCancel()}>
              <Close />
            </div>
          </div>
          <div ref={bodyRef} className={cx('modal-body', { 'without-padding': withoutPadding })}>
            {modalBody}
          </div>
          
          {hasFooter ? (
            <div className="modal-footer">
              <div className="modal-button__container">
                {customButtons !== null ? (
                  customButtons
                ) : (
                  <>
                    <button
                      type="button"
                      className="modal-button modal-button__cancel"
                      onClick={() => onCancel()}
                    >
                      {cancelText !== null ? cancelText : 'Cancel'}
                    </button>
                    <button
                      className={cx('modal-button modal-button__confirm', {
                        disabled: confirmDisabled,
                        loading: confirmLoading,
                      })}
                      type="submit"
                      disabled={confirmDisabled}
                      onClick={() => onConfirm()}
                    >
                      {confirmText !== null ? confirmText : 'Save'}
                    </button>
                  </>
                )}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
